import React, { useEffect, useState } from "react";
import AppDataTable from "./AppDataTable";
import { getAllowClient } from "../../interpreter/clients";
import Icon from "@mdi/react";
import { mdiKeyVariant, mdiAccountBoxOutline } from "@mdi/js";
import "./AppDataTable.css";

export const ClientList = ({ clients, setClients, openModal }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClients = async () => {
      setLoading(true);
      try {
        const response = await getAllowClient();
        if (response?.result) {
          setClients(response.clients_content || []);
        } else {
          console.warn("No se encontraron clientes.");
        }
      } catch (error) {
        console.warn("Error al cargar los clientes.");
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, []);

  const columns = [
    {
      name: "Código",
      selector: (row) => row.id_clientInternal,
      sortable: true,
      center: true,
      width: "90px",
      minWidth: "70px",
    },
    {
      name: "Nombre y Apellido",
      selector: (row) => row.full_name,
      sortable: true,
      center: true,
      wrap: true,
      grow: 2,
      minWidth: "140px",
    },
    {
      name: "Teléfono",
      selector: (row) => row.phoneNumber,
      sortable: true,
      center: true,
      minWidth: "110px",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      center: true,
      wrap: true,
      grow: 2,
      minWidth: "160px",
    },
    {
      name: "Acciones",
      cell: (row) => (
        <div className="table-actions table-actions--stack-sm">
          <button
            type="button"
            onClick={() => openModal("reset", row)}
            className="table-action table-action--labeled table-action--danger"
            title="Restablecer contraseña del cliente"
          >
            <Icon path={mdiKeyVariant} size={0.95} />
            <span className="table-action__label">Restablecer clave</span>
          </button>
          <button
            type="button"
            onClick={() => openModal("data", row)}
            className="table-action table-action--labeled table-action--primary"
            title="Ver información del cliente"
          >
            <Icon path={mdiAccountBoxOutline} size={0.95} />
            <span className="table-action__label">Ver cliente</span>
          </button>
        </div>
      ),
      center: true,
      minWidth: "220px",
      grow: 1,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div>
      {loading ? (
        <div className="table-loading">
          <div className="table-loading__spinner" role="status" aria-label="Cargando clientes" />
        </div>
      ) : (
        <AppDataTable
          columns={columns}
          data={clients}
          noDataComponent={<p className="table-empty">No hay clientes registrados.</p>}
        />
      )}
    </div>
  );
};
